<div class="picklist-packing-table__wrapper">
  <table class="table">
    <thead class="table-info">
      <th>Bill To</th>
      <th>Ship To</th>
      <th>Details</th>
      <th>Action</th>
    </thead>
    <tbody>
      <td [innerHTML]="orderData.invoice.billToDetails"></td>
      <td [innerHTML]="orderData.invoice.shipToDetails"></td>
      <td [innerHTML]="orderData.invoice.otherDetails"></td>
      <td class="p-0 text-dark">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <lum-ui-icon icon="menu-horizontal" color="#36363A"></lum-ui-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="exportPackingSlipEvent.emit(orderData.id)">
            Export Packing Slip
          </button>
        </mat-menu>
      </td>
    </tbody>
  </table>
</div>
